import store from '@/store/store';

export default {
  path: 'referrals/:id',
  name: 'app-view-referral',
  component: () => import('@/views/app/view_referral/ViewReferral.vue'),
  meta: {
    pageTitle: ''
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'view_referral.header_title';

    const referralsResource = await store.state.router.privateRoot.$request().$get('referrals');
    store.commit('router/updateRouteProp', {
      property: 'referralsResource',
      value: referralsResource
    });

    const referralResource = await referralsResource.$request().$get('referral', {id: to.params.id});
    store.commit('router/updateRouteProp', {
      property: 'referralResource',
      value: referralResource
    });

    next();
  },
  props: () => ({
    referralResource: store.state.router.referralResource
  })
};
